import { render } from "./GlobalContainer.vue?vue&type=template&id=2a2d1959&scoped=true"
import script from "./GlobalContainer.vue?vue&type=script&lang=js"
export * from "./GlobalContainer.vue?vue&type=script&lang=js"

import "./GlobalContainer.vue?vue&type=style&index=0&id=2a2d1959&scoped=true&lang=css"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2d1959"]])

export default __exports__